import React from 'react'
import moment from 'moment'
import 'moment/dist/locale/sv'
moment.locale('sv')

interface IHeaderCellProps {
  date: moment.Moment
  width: number
}

const HeaderCell: React.FC<IHeaderCellProps> = ({ date, width }) => {
  return (
    <span style={{ verticalAlign: 'middle' }}>
      {moment(date)
        .format(width > 60 ? 'ddd DD' : 'DD')
        .toUpperCase()}
    </span>
  )
}

export default HeaderCell
